import React, { useState } from "react";
import "./Contact.css";
import contact from "../../assets/images/contact.jpg";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    telephone: "",
    email: "",
    raison: "",
    autreRaison: "", // 👈 nouveau champ
    message: "",
  });

  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (res.ok) {
      setPopupMessage(data.message || "✅ Message envoyé avec succès !");
      setShowPopup(true);
      setFormData({
        nom: "",
        prenom: "",
        telephone: "",
        email: "",
        raison: "",
        autreRaison: "",
        message: "",
      });
    } else {
      setPopupMessage("❌ Erreur : " + (data.message || "Une erreur est survenue."));
      setShowPopup(true);
    }
  } catch (err) {
    setPopupMessage("❌ Erreur lors de l'envoi.");
    setShowPopup(true);
  }
};


  return (
    <div className="contact-background">
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <p>{popupMessage}</p>
            <button onClick={() => setShowPopup(false)}>Fermer</button>
          </div>
        </div>
      )}

      <div className="contact-container">
        <div className="contact-image">
          <img src={contact} alt="Contact" />
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Contactez-nous</h2>
          <div className="form-row">
            <input name="nom" value={formData.nom} onChange={handleChange} placeholder="Nom" required />
            <input name="prenom" value={formData.prenom} onChange={handleChange} placeholder="Prénom(s)" required />
          </div>
          <div className="form-row">
            <input name="telephone" value={formData.telephone} onChange={handleChange} placeholder="Téléphone" required />
            <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="Email" required />
          </div>
          <div className="form-row">
            <select name="raison" value={formData.raison} onChange={handleChange} required>
              <option value="">-- Sélectionnez une raison --</option>
              <option value="rendez-vous">Rendez-vous préliminaire</option>
              <option value="proposition d'affaire">Proposition d'affaire</option>
              <option value="proposition de collaboration">Proposition de collaboration</option>
              <option value="demande d'info">Demande d'information sur le service</option>
              <option value="autre">Autre à préciser</option>
            </select>
          </div>

          {/* 👇 Input visible si "autre" est choisi */}
          {formData.raison === "autre" && (
            <div className="form-row">
              <input
                name="autreRaison"
                value={formData.autreRaison}
                onChange={handleChange}
                placeholder="Veuillez préciser..."
                required
              />
            </div>
          )}

          <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Votre message..." required />
          <button type="submit">Envoyer</button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
